import SiafLiteApiRepository from "../../external/siafLiteApi";

class PdvOfflineService {
  constructor() {
    this.urlBase = "/fiscal/pdv-offline";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }
}

export default PdvOfflineService;